import type { FC } from "react";
import { ChatRecipientList } from "web_myplann/Chat/Components/List/ChatRecipientList";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	recipients: AgentAssignedListItemResponseDTO[];
	onClose: () => void;
	onSelect: (advisorId: string) => void;
};

export const ChatRecipientPickerDrawer: FC<Props> = ({
	open,
	recipients,
	onClose,
	onSelect,
}) => {
	const { t } = useResource();

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			grabber
			title={t(Resources.Chat.Recipients.title)}
		>
			<ChatRecipientList recipients={recipients} onSelect={onSelect} />
		</MyPlannDrawer>
	);
};
